import PropTypes from "prop-types";
import React from "react";

import IconHeader from "../../../../../../components/IconHeader";
import "./style.scss";

class PopupPageDecoration extends React.Component {
  render() {
    return (
      <div
        className="wrapper"
        style={{ paddingTop: "2vw", width: "100%", boxSizing: "border-box" }}
      >
        <div style={{ paddingBottom: "15vw" }}>
          <IconHeader />
        </div>
        <div className="popup-content">{this.props.children}</div>
      </div>
    );
  }
}

PopupPageDecoration.propTypes = {
  isVertical: PropTypes.bool,
};

export default PopupPageDecoration;
